export default "__VITE_ASSET__7jmophcI__"